import React from 'react';
import './MenuIconTutorial.css';

const MenuIconTutorial = (props: any) => {
	const onChangeValueKeyboard = (e:any)=> {
		if(e.keyCode == 32 || e.keyCode == 13 && props.onClick){ //32 - spacebar, 36 - enter
			props.onClick();
		}
	};

	return (
		<div className="timer-menu-background2 modal-disable-select" 
			onClick={props.onClick}
			tabIndex={0}
			aria-label="pause"
			role="button"
			onKeyDown={onChangeValueKeyboard}>
			<div className="timer-menu2">
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>);
};

export default MenuIconTutorial;